import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Tooltip } from '@mui/material';
import React from 'react';

type ConfigFieldLabelProps = {
  fieldKey: string;
  label: string;
  dirtyFields: Set<string>;
  /** Longer "(i)" explanation shown on hover/focus of the info icon. */
  tooltip?: React.ReactNode;
};

export default function ConfigFieldLabel({
  fieldKey,
  label,
  dirtyFields,
  tooltip,
}: ConfigFieldLabelProps) {
  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
      {label}
      {dirtyFields.has(fieldKey) && (
        <Box component="span" sx={{ ml: 0.5, fontWeight: 'bold', color: 'text.secondary' }}>
          *
        </Box>
      )}
      {tooltip && (
        <Tooltip title={tooltip} arrow placement="top">
          <Box
            component="span"
            aria-label={`About ${label}`}
            sx={{ display: 'inline-flex', ml: 0.5, cursor: 'help' }}
          >
            <InfoOutlinedIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
          </Box>
        </Tooltip>
      )}
    </Box>
  );
}
